<script lang="ts">
  export let content: any;

  const tags: Record<string, string> = {
    foto: "Foto",
    video: "Video",
    breakingNews: "Breaking",
    "breaking news": "Breaking",
    interviu: "Interviu",
  };

  let has_tag: string | null = null;

  if (content?.tags?.includes("foto")) {
    has_tag = "foto";
  } else if (content?.tags?.includes("video")) {
    has_tag = "video";
  } else if (content?.tags?.includes("interviu")) {
    has_tag = "interviu";
  } else if (content?.tags?.includes("breaking news")) {
    if (
      new Date().getTime() - new Date(content.published_at).getTime() <
      1000 * 60 * 60 * 24
    ) {
      has_tag = "breakingNews";
    }
  }
</script>

{#if has_tag && tags[has_tag]}
  <span
    class="content-tag"
    class:foto={has_tag === "foto"}
    class:video={has_tag === "video"}
    class:interviu={has_tag === "interviu"}
    class:breakingNews={has_tag === "breakingNews"}
  >
    {tags[has_tag]}
  </span>
{/if}

<style lang="scss">
  span.content-tag {
    text-transform: uppercase;
    display: inline-block;
    padding: 2px 5px;
    color: #fff;
    margin-right: 4px;
    border-radius: 2px;
    font-family: "Arial Narrow", "Helvetica Condensed", Impact, sans-serif;
    font-size: 0.8em;
    font-weight: 700;
    vertical-align: middle;
    line-height: 1.2;
  }

  span.foto {
    background-color: #ff7f50;
  }

  span.video {
    background-color: #4986c9;
  }

  span.interviu {
    background-color: #2348df;
  }

  span.breakingNews {
    background-color: #f1011b;
  }
</style>
